import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { css } from 'glamor'

const rotate = css.keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' }
})

const Spinner = glamorous.div(({ size }) => ({
  width: size,
  height: size,
  backgroundImage: `url(${require('./loading-spinner.png')})`,
  backgroundSize: 'contain',
  animation: `${rotate} 900ms infinite linear`,
  transform: 'translateZ(0)'
}))

Spinner.propTypes = {
  size: PropTypes.number
}

Spinner.defaultProps = {
  size: 12
}

export default Spinner



// WEBPACK FOOTER //
// ./src/components/common/LoadingSpinner.js